import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Rocket, Lightbulb, Network, BookOpen, Info } from "lucide-react";
import { isActive } from "../lib/nav.js";

const links = [
  { label: "Home", href: "/home", icon: Home },
  { label: "Boost Innovation", href: "/boost-innovation", icon: Rocket },
  { label: "Solutions & Insights", href: "/solutions-and-insights", icon: Lightbulb },
  { label: "Operations Hub", href: "/operations-hub/engagement-state-machine", icon: Network },
  {
    label: "Resources & Reusables",
    href: "/resources-and-reusables/code-contribution",
    icon: BookOpen,
  },
];

export default function Sidebar() {
  const path = useLocation();

  return (
    <aside className="sidebar">
      <nav className="side-nav" aria-label="Primary navigation">
        {links.map((l) => {
          const Icon = l.icon;
          return (
            <Link
              to={l.href}
              key={l.label}
              className={`side-link ${isActive(l.href, path.pathname) ? "is-active" : ""}`}
            >
              <span className="side-ico" aria-hidden="true">
                <Icon className="side-icon-img" size={24} />
              </span>
              <span className="side-text">{l.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="side-footer">
        <Link
          to={"/about/about-its"}
          className={`side-link ${isActive("/about/about-its", path.pathname) ? "is-active" : ""}`}
        >
          <span className="side-ico" aria-hidden="true">
            <Info className="side-icon-img" size={24} />
          </span>
          <span className="side-text">About Us</span>
        </Link>
      </div>
    </aside>
  );
}
